// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__3plnO","content_border":"Content_content_border__1y0OI","content__cancel":"Content_content__cancel__3kaqU","backdrop":"Content_backdrop__agl9G"};